function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2779 13.8891C17.9527 13.8891 18.519 14.446 18.4158 15.1123C17.8106 19.0323 14.4548 21.9428 10.4074 21.9428C5.92952 21.9428 2.30005 18.3134 2.30005 13.8365C2.30005 10.1481 5.10215 6.7123 8.25689 5.93546C8.93479 5.76809 9.62952 6.24493 9.62952 6.94283C9.62952 11.6712 9.78847 12.8944 10.6864 13.5597C11.5843 14.2249 12.64 13.8891 17.2779 13.8891Z",
  stroke: "#055445",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.6926 9.95157C21.7463 6.91368 18.0147 2.01684 13.4674 2.10105C13.1137 2.10736 12.8305 2.4021 12.8147 2.75473C12.7 5.25263 12.8547 8.48947 12.9411 9.95684C12.9674 10.4137 13.3263 10.7726 13.7821 10.7989C15.2905 10.8853 18.6453 11.0032 21.1074 10.6305C21.4421 10.58 21.6874 10.2895 21.6926 9.95157Z",
  stroke: "#055445",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPiechart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiechart);
export default __webpack_public_path__ + "static/media/piechart.dda2f062b3b140ff1fa259113a2d5ccc.svg";
export { ForwardRef as ReactComponent };